export function recordingError(error: unknown): { permissionDenied: boolean; message: string } {
  const name = error instanceof Error ? error.name : "";
  if (name === "NotAllowedError" || name === "PermissionDeniedError" || name === "SecurityError") {
    return { permissionDenied: true, message: "Microphone permission is off. Tap Allow microphone to try again, or enable it in app settings." };
  }
  if (name === "NotFoundError" || name === "DevicesNotFoundError") {
    return { permissionDenied: false, message: "No microphone was found. Connect one or type your note." };
  }
  if (name === "NotReadableError" || name === "TrackStartError" || name === "AbortError") {
    return { permissionDenied: false, message: "The microphone could not start. Check the phone's microphone privacy switch and close other recording apps, then try again." };
  }
  return { permissionDenied: false, message: "Recording could not start. Try again or type your note." };
}
